module.exports = __webpack_public_path__ + "static/imgs/logo-top.245a4b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo-top.jpg
// module id = zDRn
// module chunks = 56